export const shapeUpdateAccountPayload = (args) => {
  const {
    inputsData: {
      regInputEmail,
      updateEmailInputPassword,
      regFirstName,
      regLastName,
      regPhoneNumber,
      regMobileNumber,
      deliveryAddress1,
      deliveryAddress2,
      suburb,
      postcode,
    },
    dropdownsData: {
      selectedPrefix,
      selectedDobDay,
      selectedDobMonth,
      selectedDobYear,
      selectedState,
      selectedCountry,
    },
    changeEmailAddress,
  } = args;

  const requestPayloadModel = {
    Account: {
      Email: regInputEmail || null,
      Password: updateEmailInputPassword || null,
      ConfirmPassword: null,
      Title: selectedPrefix || null,
      FirstName: regFirstName || null,
      LastName: regLastName || null,
      DOBDay: selectedDobDay || null,
      DOBMonth: selectedDobMonth || null,
      DOBYear: selectedDobYear || null,
      PhoneNumber: regPhoneNumber || '',
      MobileNumber: regMobileNumber || '',
      SubscribeNewsletters: false,
      ChangeEmailAddress: changeEmailAddress,
      Redirect: false,
      RedirectUrl: null,
      ErrorMessage: null,
      ComplexErrorMessage: null,
      SuccessMessage: null,
    },
    AddressModel: {
      AddressId: null,
      Street1: deliveryAddress1 || null,
      Street2: deliveryAddress2 || null,
      AddressLine3: null,
      Suburb: suburb || null,
      Postcode: postcode || null,
      StateId: null,
      State: selectedState || null,
      ReferenceStates: [],
      StateDescription: null,
      CountryId: null,
      PrimaryIndicator: null,
      CountryDescription: selectedCountry || null,
      ShippingMethod: 0,
      ToBeDeleted: false,
      FullAddress: null,
      ErrorMessage: null,
    },
  };

  return requestPayloadModel;
};
